import React from 'react';
import { Select as SelectAntd, SelectProps } from 'antd';

export interface SelectOption {
  id: string;
  label: string;
}

export interface SelectProp extends SelectProps {
  options: SelectOption[];
}

function Select({ options, ...props }: SelectProp) {
  return (
    <SelectAntd
      {...props}
      options={options.map(({ id, label }) => ({
        value: id,
        label,
      }))}
    />
  );
}

export default Select;
